var utils = require('../../../lib/utils')

module.exports = {
	config: {
	},

	model: {
		dirtyAssignedTags: {},
		dirtySubFields: {},
		config: {
			// tagScope: 'routes',
			// relationsMappedBySimpleArray: false,
			// relationConfig: {
			// 	subFormAlias: 'cms_entities_categories',
			// 	subFormAliasContainer: 'children'
			// },
			// showSummary: true,
			// showSummaryFullPaths: true,
			// refreshResourcesOnComponentRefresh: false
			// categoryEntityType: 'routes',
			// supportCollapsibleTags: false,
			// maxOpenLevelOnInit: 1,
			// selectParentsGranted: true,
			isHidden: false
		}
	},

	events: {
		open: {
			type: 'click',
			action: function(event) {
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				var $realTarget = $target.closest('button');

				if($realTarget.length > 0) {
					var mode = $realTarget.data('buttonMode');
					if(mode === 'empty'){
						self.emptyAssignedTags();
					} else {
						var $potentialParentModal = $target.closest('.base_modal_modal');
						var overruleCKEditor = ($potentialParentModal.length > 0 && $potentialParentModal.hasClass('overruleCKEditor'))

						self.open(undefined, undefined, undefined, undefined, overruleCKEditor);
					}
				}
			}
		}
	},

	methods: {
		sanitizeResources(storage){
			this.initModel(storage);
		},

		initModel: function(storage){
			var self = this;
			storage = storage || window.storage;

			self.model.turnedOffTagCategoryManagement = storage && storage.user ? storage.user.hasAccessTo('usage:turnedOffTagCategoryManagement', self.scope) : false
			self.model.preparedAssignedCategories = {}
			self.closest('base_form_form', function(formComponent){
				var assignedTags, primaryKey, resourceData, inheritedCategories, modelKey, isDirty, fieldData;
				var prepareSummary = false

				// use different data formats and resources according to the source (live- or dirty-data).
				// e.g., dirty data may be of interest in cases of refreshes.
				for(var resource of [{
					resourceData: (formComponent.resourceData || {}).data,
					isDirty: false,
					modelKey: 'assignedTags'
				},{
					resourceData: ((formComponent.model || {}).dirtyFields || {}).data,
					isDirty: true,
					modelKey: 'dirtyAssignedTags'
				}]){

					// identify data to use
					resourceData = resource.resourceData || {}
					modelKey = resource.modelKey
					isDirty = resource.isDirty
					if(isDirty){
						fieldData = formComponent.getFieldValue(this.model.fieldCode, 'dirty')
					} else {
						fieldData = formComponent.getFieldValue(this.model.fieldCode, 'live')
					}

					// prepare inheritedCategories if necessary
					if(!isDirty){
						if(
							(primaryKey = (resourceData.attributes || {})[resourceData.primaryKey || 0] || 0) &&
							(inheritedCategories = (this.model['tag-picker-data'] || {}).inheritedCategories || {}) &&
							inheritedCategories[primaryKey]
						){
							self.model.inheritedCategories = inheritedCategories[primaryKey]
						} else {
							self.model.inheritedCategories = {}
						}
					}

					// translate mapping in case of "relationsMappedBySimpleArray" usage
					if((self.model.config || {}).relationsMappedBySimpleArray){
						self.model[modelKey] = [];
						var k, keys;
						for(k in fieldData || []){
							keys = String(fieldData[k] || '').split('_');
							if(keys.length === 2){
								// dirty data does not support an attributes-key.
								if(isDirty){
									self.model[modelKey].push({
										categoryID: 	keys[0] * 1,
										categoryDataID: keys[1] * 1
									});
								} else {
									self.model[modelKey].push({
										attributes: {
											categoryID: 	keys[0] * 1,
											categoryDataID: keys[1] * 1
										}
									});
								}
							}
						}

						if(self.model[modelKey].length > 0){
							prepareSummary = true
						}
					}
					// default handling by subFormAlias and its' container
					else {
						if (
							self.model.config &&
							self.model.config.relationConfig &&
							self.model.config.relationConfig.subFormAlias &&
							self.model.config.relationConfig.subFormAliasContainer &&
							(assignedTags = ((resourceData[self.model.config.relationConfig.subFormAliasContainer] || {})[self.model.config.relationConfig.subFormAlias] || {}).data || []).length > 0
						){
							// get rid of attributes-key if necessary
							if(isDirty){
								self.model[modelKey] = {}
								for(var aT in assignedTags){
									var attributes = assignedTags[aT].attributes || {}
									self.model[modelKey][`${attributes.categoryID}_${attributes.categoryDataID}`] = attributes
								}
							} else {
								self.model[modelKey] = assignedTags;

								// prepare assignedCategories if necessary
								if(self.model.config.tagScope === 'routes'){
									utils.prepareCategories(self.model.preparedAssignedCategories, assignedTags, storage, self.model.inheritedCategories, self.scope, true);
								}
							}

							prepareSummary = true
						}
					}
				}

				// prepare summary if necessary
				if(prepareSummary){
					self.prepareSummary()
				}
			})

		},

		prepareSummary: function(){
			if(!(this.model.config || {}).showSummary) return;

			var options = (this.model['tag-picker-data'] || {}).options || [];
			var optionalCategories = (this.model.config || {}).tagScope === 'routes'
			var aT, c, cD, categoryIndex, category, preparedCategory, categoryDataIndex, categoryData, assignedTagData, assignedTagAttributes, dirtyTagID;
			var parentCategoryDataIndex;
			var showHiddenCategory

			this.model.summaryOfAssignedCategories = {};
			var summaryOfAssignedCategories = this.model.summaryOfAssignedCategories;

			for(c in options || []) {
				category = options[c];
				categoryIndex = ((category.resources || {}).sort || 0) + '-' + category.id
				preparedCategory = (this.model.preparedAssignedCategories || {})[category.id] || {}

				// check if optionalCategories is turned off by atom-config or if the category has been selected.
				if(!optionalCategories || (!preparedCategory.turnedOff && (!preparedCategory.turnedOffByInheritance || preparedCategory.turnedOn)) || this.model.turnedOffTagCategoryManagement){
					showHiddenCategory = optionalCategories && (preparedCategory.turnedOff || (preparedCategory.turnedOffByInheritance && !preparedCategory.turnedOn)) && this.model.turnedOffTagCategoryManagement

					// check if category is assigned
					for(aT in this.model.assignedTags || []) {
						assignedTagAttributes = (this.model.assignedTags[aT] || {}).attributes || {};
						if(!summaryOfAssignedCategories[categoryIndex] && assignedTagAttributes.categoryID === category.id){
							summaryOfAssignedCategories[categoryIndex] = {
								name: 				category.name,
								showHiddenCategory: showHiddenCategory,
								children: 			{}
							};
							break;
						}
					}

					// check if category is assigned dirty
					for(dirtyTagID in this.model.dirtyAssignedTags || []) {
						assignedTagAttributes = this.model.dirtyAssignedTags[dirtyTagID] || {};
						// support data format including as well as excluding attributes-key
						assignedTagAttributes = assignedTagAttributes.attributes || assignedTagAttributes;
						if(assignedTagAttributes.categoryID === category.id){
							showHiddenCategory = (
								optionalCategories &&
								this.model.turnedOffTagCategoryManagement &&
								(
									(assignedTagAttributes.type === 'delete' && preparedCategory.turnedOffByInheritance)
									||
									(assignedTagAttributes.type !== 'delete' && !Boolean(assignedTagAttributes.enabled))
								)
							);
							summaryOfAssignedCategories[categoryIndex] = {
								name: 				category.name,
								showHiddenCategory: showHiddenCategory,
								children: 			{}
							};
							break;
						}
					}

					if(summaryOfAssignedCategories[categoryIndex]){
						for(cD in category.children || []) {
							categoryData = category.children[cD];
							categoryDataIndex = ((categoryData.resources || {}).sort || 0) + '-' + categoryData.id

							// collect names of parents
							categoryData.names = []
							parentCategoryDataIndex = Object.values(categoryData.indexChain)
							if(parentCategoryDataIndex.length > 1){
								parentCategoryDataIndex.pop()
								parentCategoryDataIndex = parentCategoryDataIndex.pop()
								if(category.children[parentCategoryDataIndex]){
									categoryData.names = utils.copy(category.children[parentCategoryDataIndex].names || [])
								}
							}
							categoryData.names.push(categoryData.name);

							// check if categoryData is assigned
							for(aT in this.model.assignedTags || []) {
								assignedTagData = this.model.assignedTags[aT] || {};
								assignedTagAttributes = assignedTagData.attributes || {};
								if(!summaryOfAssignedCategories[categoryIndex].children[categoryDataIndex] && assignedTagAttributes.categoryID === category.id && assignedTagAttributes.categoryDataID === categoryData.id){
									summaryOfAssignedCategories[categoryIndex].children[categoryDataIndex] = {
										name: 	categoryData.name,
										names: 	categoryData.names,
										type: 	assignedTagData.type || 'exists', // assignedTagData may represent a protocolAction and therefor have another type than 'exists' although it is rendered as if it was a specific state of this tag-picker.
									};
									break;
								}
							}

							// check if category is assigned dirty
							for(dirtyTagID in this.model.dirtyAssignedTags || []) {
								assignedTagAttributes = this.model.dirtyAssignedTags[dirtyTagID] || {};
								// support data format including as well as excluding attributes-key
								assignedTagAttributes = assignedTagAttributes.attributes || assignedTagAttributes;
								if(assignedTagAttributes.categoryID === category.id && assignedTagAttributes.categoryDataID === categoryData.id){
									summaryOfAssignedCategories[categoryIndex].children[categoryDataIndex] = {
										name: 	categoryData.name,
										names: 	categoryData.names,
										type: 	assignedTagAttributes.type || (summaryOfAssignedCategories[categoryIndex].children[categoryDataIndex] || {}).type || 'create'
									};
									break;
								}
							}
						}
					}
				}
			}
		},

		open: function(previouslyAssinedTags, onDecisionCallback, overrideAction, enhancedResourceRegisterContent, overruleCKEditor = false){
			var self = this;
			self.model.onDecisionCallback = onDecisionCallback;
			var actionName 	= overrideAction || 'showTagAssignment';
			var actionID 	= actionName + '_inEffect';

			self.performAndStoreAction(
				actionID,
				self.prepareAction(
					actionName,
					undefined,
					{
						tagPickerButtonStorage: {
							onDecisionCallback: onDecisionCallback
						},
						tags: {
							options: 					(self.model['tag-picker-data'] || {}).options || [],
							inheritedCategories: 		self.model.inheritedCategories || {},
							assignedTags: 				self.model.assignedTags || previouslyAssinedTags || [],
							preparedAssignedCategories: self.model.preparedAssignedCategories || {},
							dirtyAssignedTags: 			self.model.dirtyAssignedTags,
							optionalCategories: 		(self.model.config || {}).tagScope === 'routes',
							useNormalDirtyColor: 		(self.model.config || {}).useNormalDirtyColor === true,
							supportCollapsibleTags: 	(self.model.config || {}).supportCollapsibleTags === true,
							maxOpenLevelOnInit: 		(self.model.config || {}).maxOpenLevelOnInit || 1,
							selectParentsGranted: 		(self.model.config || {}).selectParentsGranted !== false,
						},
						enhanced: enhancedResourceRegisterContent || {}
					}, {
						source: {
							load: {
								componentData: {
									config: {
										overruleCKEditor: overruleCKEditor
									}
								}
							}
						}
					}
				),
				true
			)
		},

		emptyAssignedTags: function(){
			var self = this;
			var lastChildChangedOptions;

			if((self.model.config || {}).relationsMappedBySimpleArray){
				self.model.assignedTags = [];
				self.model.dirtyAssignedTags = {};
				this.triggerClosest('onChildChanged', {
					fieldCode: self.model.fieldCode,
					value: []
				});
			} else {

				// remove dirty relationship entries if necessary
				utils.forEachReverse(self.model.dirtyAssignedTags, function(tag){
					if(tag){
						var tagKey = `${tag.categoryID}_${tag.categoryDataID}`
						if(tag.type !== 'delete'){
							delete self.model.dirtyAssignedTags[tagKey]
						}
						self.triggerClosest('onChildChanged', (lastChildChangedOptions = {
							isRelation: true,
							value: {
								attributes: {}
							},
							fieldCode: self.model.fieldCode,
							relationConfig: (self.model.config || {}).relationConfig,
							type: tag.type,
							relationDataIndex: tag.relationDataIndex
						}));
					}
				});

				// remove relationship entries if necessary
				utils.forEachReverse(self.model.assignedTags, function(tagData, tagRelationDataIndex){
					var tag = (tagData || {}).attributes || {}
					if(tag){
						var tagKey = `${tag.categoryID}_${tag.categoryDataID}`
						self.model.dirtyAssignedTags[tagKey] = {
							...tag,
							type: 'delete',
							relationDataIndex: tagRelationDataIndex
						}
						self.triggerClosest('onChildChanged', (lastChildChangedOptions = {
							isRelation: true,
							value: {
								attributes: tag
							},
							fieldCode: self.model.fieldCode,
							relationConfig: (self.model.config || {}).relationConfig,
							type: 'delete',
							relationDataIndex: tagRelationDataIndex
						}));
					}
				});

				if(lastChildChangedOptions){
					lastChildChangedOptions.isLastRelationElement = true;
					this.triggerClosest('onChildChanged', lastChildChangedOptions);
				}
			}

			self.prepareSummary();
			self.refresh(false);
		},

		tagToggle: function(categoryID, categoryDataID){
			var self = this;
			var tagKey = `${categoryID}_${categoryDataID}`

			if(self.model.dirtyAssignedTags[tagKey]){
				delete self.model.dirtyAssignedTags[tagKey];
			} else {
				self.model.dirtyAssignedTags[tagKey] = {
					type: 'create',
					categoryID: categoryID * 1,
					categoryDataID: categoryDataID * 1,
					enabled: null
				};
			}

			this.trigger('onDecision', {
				decisionOptions: {
					decisionType: 'decisionComponent',
					dirtyAssignedTags: self.model.dirtyAssignedTags
				}
			})
		}
	},

	hooks: {
		onDecision: function($element, options){
			var self = this;
			var onDecisionCallback = self.model.onDecisionCallback;

			if(!onDecisionCallback){
				var actionKey;
				for(actionKey in self.actions){
					if(
						self.actions[actionKey].ready
					){
						onDecisionCallback = ((self.actions[actionKey].resourceRegister || {}).tagPickerButtonStorage || {}).onDecisionCallback;
						break;
					}
				}
			}

			if(utils.isFunction(onDecisionCallback)){
				options.categoryEntityType = (self.model.config || {}).categoryEntityType;
				onDecisionCallback(options);
			}
			// should this decision be translated into a field change, or ...
			else if(options && options.decisionOptions && options.decisionOptions.dirtyAssignedTags){

				var lastChildChangedOptions;

				// save dirtyAssignedTags in case of reopen tagAssignment
				var lastDirtyAssignedTags = utils.simpleCopy(this.model.dirtyAssignedTags);
				this.model.dirtyAssignedTags = options.decisionOptions.dirtyAssignedTags || {};

				if((self.model.config || {}).relationsMappedBySimpleArray){
					if(!this.model.originalDataJSON){
						if(this.model.dataJSON) this.model.originalDataJSON = utils.simpleCopy(this.model.dataJSON);
						else 					this.model.originalDataJSON = [];
					}
					var newValue = utils.simpleCopy(this.model.originalDataJSON);
					var dirtyValues = this.model.dirtyAssignedTags || {};
					var d, i;
					for(d in dirtyValues){
						i = newValue.indexOf(d);
						if(i > -1){
							newValue.splice(i, 1);
						}
						if(dirtyValues[d].type === 'create'){
							newValue.push(d);
						}
					}

					self.triggerClosest('onChildChanged', {
						value: 		newValue.sort(),
						fieldCode: 	self.model.fieldCode
					});
				} else {
					// remove relationship entries if necessary
					var lastDirtyTag;
					utils.forEachReverse(lastDirtyAssignedTags, function(dirtyTag, dirtyTagID){
						if(!self.model.dirtyAssignedTags[dirtyTagID]){
							lastDirtyTag = lastDirtyAssignedTags[dirtyTagID];
							self.triggerClosest('onChildChanged', (lastChildChangedOptions = {
								isRelation: true,
								value: {
									attributes: {}
								},
								fieldCode: self.model.fieldCode,
								relationConfig: (self.model.config || {}).relationConfig,
								type: lastDirtyTag.type,
								relationDataIndex: lastDirtyTag.relationDataIndex
							}));
						}
					});

					// tell parent form about all dirty tagAssignments
					var relationAttributes;
					utils.forEach(options.decisionOptions.dirtyAssignedTags, function(dirtyTag, dirtyTagID){
						relationAttributes = {
							entityType: (self.model.config || {}).categoryEntityType,
							categoryID: dirtyTag.categoryID,
							categoryDataID: dirtyTag.categoryDataID
						};
						if (dirtyTag.categoryDataID === null) {
							relationAttributes.enabled = dirtyTag.enabled
						}
						relationAttributes[dirtyTag.primaryKey || 'id'] = dirtyTag.id;
						self.triggerClosest('onChildChanged', (lastChildChangedOptions = {
							isRelation: true,
							value: {
								attributes: relationAttributes
							},
							fieldCode: self.model.fieldCode,
							relationConfig: (self.model.config || {}).relationConfig,
							type: dirtyTag.type,
							relationDataIndex: dirtyTag.relationDataIndex
						}));
					});

					// trigger one extra in case its necessary to react exactly once the change are done
					if(lastChildChangedOptions){
						lastChildChangedOptions.isLastRelationElement = true;
						this.triggerClosest('onChildChanged', lastChildChangedOptions);
					}
				}


				this.prepareSummary();
				this.refresh(false);
			}
			// ... should the trigger be handed over to the next onDecision handler.
			else {
				this.triggerClosest('onDecision', options);
			}
		},

		onChildChanged: function($element, options){
			var self = this;

			// remember dirty subFields (e.g., <fieldCode>_tagConnection) for refreshes.
			self.model.dirtySubFields = self.model.dirtySubFields || {};
			self.model.dirtySubFields[options.fieldCode] = options.value;

			self.parent(function(parentComponent){
				parentComponent.trigger('onChildChanged', options);
			});
		}
	},

	handlers: [
		{
			name: 'afterTagsUpdate',
			componentClass: '',
			handle: function(callerComponent){
				var self = this;

				self.refresh(true, undefined, undefined, undefined, function(){
					// init model after refresh (e.g., used for summary and other prerequisites)
					self.initModel()
					var actionKey, tagResourceRegister, containerComponent;
					for(actionKey in self.actions){
						if(
							self.actions[actionKey].ready &&
							(tagResourceRegister = (self.actions[actionKey].resourceRegister || {}).tags) &&
							(containerComponent = ((self.actions[actionKey].source || {}).load || {}).component)

						){
							tagResourceRegister.options = utils.simpleCopy((self.model['tag-picker-data'] || {}).options || []);
							containerComponent.find('templates_tags_tagAssignment', function(tagAssignment){
								tagAssignment.resourceData.options = tagResourceRegister.options;
							});
						}
					}
				});
			}
		}
	]
}
